const photosTemplate = require('20220101/templates/widgets/grid/photos.hbs');
const indexTemplate = require('20220101/templates/widgets/grid/index.hbs');
import widgetMixin from "./widget-mixin.js";

const DEFAULTS = { rows: 2, cols: 5 }

class GridWidget extends widgetMixin(HTMLElement) {
  constructor() {
    super();

    this.DEFAULTS = DEFAULTS;

    this.photos = [];
    this.fetchMorePhotos = false;
  }

  processPhotos(data) {
    this.createPhotoMatrix(data.photos);
    super.processPhotos(data);
  }

  createPhotoMatrix(photos) {
    let j = -1;
    this.photoMatrix = [];

    const result = [];

    for (let i = 0; i < photos.length; i++) {
      if ((i % this.cols) === 0) {
        j++;
        this.photoMatrix[j] = [];
      }

      this.photoMatrix[j].push(photos[i]);
    }
  }

  beforeRerender() {
    if (this.photos.length > this.per) {
      this.photos = this.photos.slice(0, this.per);
    }

    if (this.photos.length < this.per) {
      this.photos = [];
      this.fetchPhotos();
    }
  }


  render() {
    console.log("rendering");
    this.per = this.cols * this.rows

    if (this.initialized) { this.beforeRerender() }


    this.renderIndex();
    this.appendPhotos(this.photos);
  }

  renderIndex() {
    const renderedIndex = indexTemplate({photos: this.photos, preferences: this.preferences, rows: this.rows, cols: this.cols,  uuid: this.uuid});
    this.shadow.innerHTML = renderedIndex;
    this.appendCustomCSS();
  }

  appendPhotos(photos) {
    const renderedPhotos = photosTemplate({photoMatrix: this.photoMatrix, preferences: this.preferences});
    this.shadow.querySelector('.l2h-photos').insertAdjacentHTML('beforeend', renderedPhotos);
    this.renderHeader();
  }

  static get observedAttributes() {
    return ["rows", "cols"].concat(super.observedAttributes)
  }

}

customElements.define('l2h-grid-widget', GridWidget);
